module.exports = __webpack_public_path__ + "media/images/winery-woman-d8d68281917beb8dc9fde796df83ecec.jpg";